import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllfund, getAllBanks } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import { Grid } from "@material-ui/core";
import ConfirmDialogListNumberlirtna from "../global/ConfirmDialogListNumberlirtna";
import ConfirmDialogAddNumberlirtna from "../global/ConfirmDialogAddNumberlirtna";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import packageJson from "../../../../package.json";
import ConfirmDialog from "../global/ConfirmDialogCon";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Orderfundcache() {
  const [fund, setfund] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [filterpaymentMethod, setFilterPaymentMethod] = useState([]);
  const [fundoption, setFundoption] = useState([]);
  const lirtna_mobile= localStorage.getItem('lirtna_mobile')

  const [mobile_number, setMobile_number] = useState(lirtna_mobile);
  const [priceamount, setPriceAmount] = useState();
  const [fundpost, setFundpost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [stringData, setStringData] = useState("");
  const [stringDataloading, setStringDataloading] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog1, setConfirmDialog1] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [data2, setdata2] = useState("");
  const [message, setmessage] = useState("");
  useEffect(() => {
    setIsLoading(true);
    getAllfund()
      .then((res) => {
        setfund(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });

    getAllBanks()
      .then((res) => {
        setBanks(res);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });

    return () => {};
  }, []);
  const initialFValues = {
    mobile_number: "",
    amount: "",
    payment_method: "",
    bank: "",
    number_transfer: "",
    image: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (fieldValues.mobile_number ===  "") {
        temp.mobile_number = "هذا الحقل مطلوب";
      } else if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } 
     
      else {
        temp.mobile_number = "";
      }
    }
    if (fundoption === "BankTransfer") {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "هذا الحقل مطلوب";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "هذا الحقل مطلوب";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "هذا الحقل مطلوب";
        } else {
          temp.image = "";
        }
      }
    } else {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "";
        } else {
          temp.image = "";
        }
      }
    }
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : " الكمية مطلوبة";
    if ("payment_method" in fieldValues)
      temp.payment_method = fieldValues.payment_method ? "" : "هذا الحقل مطلوب";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
    if (fieldValues.mobile_number !== "" && !/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number !== "" && fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } 
      else if (fieldValues.mobile_number !== "" && fieldValues.mobile_number.length == 10) {
        temp.mobile_number = "";
        const data = {
          amount: loginInput.amount,
          mobile_number: mobile_number,
        }
        axios
          .post(`${BaseUrl}/api/paymentMethod`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (typeof res.data.data === "string") {
              // Handle string data
              // Set it to a state variable or display an error message
              setStringData(res.data.data);
              setStringDataloading(true);
            } else if (Array.isArray(res.data.data)) {
              // Handle array data
              setStringDataloading(false);
              setPaymentMethod(res.data.data);
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
          });
          
        }
      else {
        temp.mobile_number = "";
      }
    
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate,validate2);

  const handleSubmit = () => {

    if (validate()) {
      setLoading(true);
      if (fundoption === "BankTransfer") {
        const bodyFormData = new FormData();
        bodyFormData.append("mobile_number", mobile_number);
        bodyFormData.append("amount", fundpost);
        bodyFormData.append("payment_method", fundoption);
        bodyFormData.append("bank", loginInput.bank);
        bodyFormData.append("number_transfer", loginInput.number_transfer);
        bodyFormData.append("image", image);
        
        axios
          .post(`${BaseUrl}/api/createOrder`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                localStorage.setItem("lirtna_mobile", '');
                window.location.reload();
              });
            } else if (res.data.status === false) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                localStorage.setItem("lirtna_mobile", '');
                window.location.reload();
              });
            }
          })   .catch((error) => {
            setLoading(false);
            if (error.response && error.response.status === 500) {
              sweetalert(error.response.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          });
      } 
      if (fundoption === "E_payment")  {
        const data = {
          mobile_number: mobile_number,
          amount: fundpost,
        };
        axios
          .post(`${BaseUrl}/api/addPaymentFatoraTransOrder`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              setLoading(false);
              const url = res.data.data.url;
              sweetalert('سيتم توجيهك الى نافذة الدفع الالكتروني', {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then((res) => {
                localStorage.setItem("lirtna_mobile", '');
                window.open(url, "_blank");
                window.location.reload();
              });
            } else if (res.data.status === false) {
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            }
          });
      }
      else {
        const data = {
          mobile_number: mobile_number,
          amount: fundpost,
          payment_method: fundoption,
        };
        axios
          .post(`${BaseUrl}/api/createOrder`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              localStorage.setItem("lirtna_mobile", '');
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            } else if (res.data.status === false) {
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            }
          });
      }
    }
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;
   
    if (fieldName === "mobile_number") {
      validate();
      setMobile_number(value);
      setLogin({ ...loginInput, mobile_number: e.target.value });
      // const data = {
      //   mobile_number: value,
      // };
      // axios
      //   .post(`${BaseUrl}/api/paymentMethod`, data, {
      //     withCredentials: true,
      //   })
      //   .then((res) => {
      //     if (typeof res.data.data === "string") {
      //       // Handle string data
      //       // Set it to a state variable or display an error message
      //       setStringData(res.data.data);
      //       setStringDataloading(true);
      //     } else if (Array.isArray(res.data.data)) {
      //       // Handle array data
      //       setStringDataloading(false);
      //       setPaymentMethod(res.data.data);
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error in API call:", error);
      //   });
    }
     else if (fieldName === "amount") {
      setFundpost(value);
      setLogin({ ...loginInput, amount: e.target.value });
    
    }
     else if (fieldName === "payment_method") {
      setFundoption(e.target.value);
      setLogin({ ...loginInput, payment_method: e.target.value })
      if (mobile_number !== "" && fundpost.length == 0) {
        const data = {
          amount: fundpost,
          mobile_number: mobile_number,
          payment_method: value,
        };

        axios
          .post(`${BaseUrl}/api/getPriceBuyAndSellOrder`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.status === 200) {
              setTimeout(() => {
                setPriceAmount(res.data.data);
              }, 1000);
            } else {
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
          });
      }
    }
  };
  const handleChange2 = (e, fieldName) => {
    const value = e.target.value;
      setFundoption(e.target.value);
      setLogin({ ...loginInput, payment_method: e.target.value })
      if (mobile_number !== "" && fundpost.length !== 0) {
        const data = {
          amount: fundpost,
          mobile_number: mobile_number,
          payment_method: value,
        };

        axios
          .post(`${BaseUrl}/api/getPriceBuyAndSellOrder`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.status === 200) {
              setTimeout(() => {
                setPriceAmount(res.data.data);
              }, 1000);
            } else {
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
          });
      }
    
  };
  const handelMethod=((e)=>{
    setFundoption(e.target.value);
     setLogin({ ...loginInput, payment_method: e.target.value })
  })
  useEffect(() => {}, [paymentMethod, validate,stringData,errors,loginInput,initialFValues]);

  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  const handlefile = (e) => {
    setLogin({ ...loginInput, [e.target.name]: e.target.files[0] });
    setImage(e.target.files[0]);
  };
  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  function handleListNumber() {
  
    axios
      .get(`${BaseUrl}/api/getMyCustomerLiretna`, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {

          setdata2(res.data.data);
          setmessage(res.data.msg);
     
        }
      });
    setConfirmDialog1({
      isOpen: true,
      title: "سجل الارقام",
      onConfirm: () => {},
    });
  }
  useEffect(() => {
    setMobile_number(lirtna_mobile)
    setLogin({ ...loginInput,mobile_number:lirtna_mobile})
  },[lirtna_mobile])
  useEffect(() => {
    const lirtna_mobile = localStorage.getItem('lirtna_mobile');
    if(lirtna_mobile) {
      setMobile_number(lirtna_mobile);
      setLogin({ ...loginInput, mobile_number: lirtna_mobile });
      // Clear the local storage after setting the state
      localStorage.removeItem('lirtna_mobile');
    } else {
      setMobile_number('');
      setLogin({ ...loginInput, mobile_number: '' });
    }
  }, []);
  return (
    <div className="main-div">
      <h3 className="titlepage">طلب رصيد ليرتنا كاش</h3>

      <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          {/* <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile_number"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "mobile_number")}
              value={mobile_number}
              className="form-control"
              error={errors.mobile_number}
              type="number"
            />
            {stringDataloading && <div style={{color:'red'}}>{stringData}</div>}{" "}
          </Grid> */}
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={10} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={(e) => handleChange(e, "mobile_number")}
                value={mobile_number}
                className="form-control"
                error={errors.mobile_number}
              />
              {stringDataloading && (
                <div style={{ color: "red" }}>{stringData}</div>
              )}{" "}
            </Grid>
            <Grid item md={2} xs={12}>
              <AddCircleIcon
                style={{ cursor: "pointer" }}
                className="svgadd"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    subTitle: "إضافة رقم الموبايل إلى سجل الارقام",
                    onConfirm: () => {},
                  });
                }}
              />
              <ConfirmDialogAddNumberlirtna
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                phone={mobile_number}
              />
              <AssignmentTurnedInIcon
                style={{ cursor: "pointer" }}
                className="svgadd1"
                onClick={() => {
                  handleListNumber()
                }}
              />
              <ConfirmDialogListNumberlirtna
                confirmDialog={confirmDialog1}
                setConfirmDialog={setConfirmDialog1}
                phone={mobile_number}
                data2={data2}
              />
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="القيمة"
              name="amount"
              variant="outlined"
              fullWidth
              value={fundpost}
              onChange={(e) => handleChange(e, "amount")}
              className="form-control"
              type="number"
              error={errors.amount}
            />
          </Grid>
        

          <Grid item md={6} xs={12}>
            <label>طريقة الدفع</label>
            <div className="select">
              <select
                className="select-text"
                name="payment_method"
                // onChange={(e) =>handelMethod(e)}
                onChange={(e) => handleChange2(e, "payment_method")}
              >
                <option selected disabled>
                  اختر طريقة الدفع
                </option>
                {Array.isArray(paymentMethod) ? (
                  paymentMethod.map((opts, i) => (
                    <option key={opts} value={opts.name}>
                      {opts.name_ar}
                    </option>
                  ))
                ) : (
                  <option disabled>{paymentMethod}</option>
                )}
              </select>
              <span className="select-highlight"></span>
              <span className="select-bar"></span>
            </div>
            {loginInput.payment_method ==''?(
            <div style={{ color: "red", fontSize: "10px" ,textAlign:'end'}}>
              {errors.payment_method}
            </div>
            ):(
              <></>
            )}

          </Grid>
          {fundoption === "BankTransfer" ? (
            <>
              <Grid item md={6} xs={12}>
                <label>البنك</label>
                <div class="select">
                  <select
                    className="form-control"
                    class="select-text"
                    name="bank"
                    onChange={handleInputChange}
                  >
                    <option selected disabled>
                      اختر البنك
                    </option>
                    {Banks.map((opts, i) => (
                      <option key={opts.id} value={opts}>
                        {opts}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                </div>
                <div style={{color:'red',fontSize:'10px'}}>{fundoption === "BankTransfer" ? errors.bank : ""}</div>
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="رقم الحوالة"
                  name="number_transfer"
                  variant="outlined"
                  fullWidth
                  onChange={handleInputChange}
                  className="form-control"
                  error={
                    fundoption === "BankTransfer" ? errors.number_transfer : ""
                  }
                  type="number"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Controls.Input
                  label="صورة الحوالة"
                  name="image"
                  variant="outlined"
                  fullWidth
                  onChange={handlefile}
                  className="form-control"
                  error={fundoption === "BankTransfer" ? errors.image : ""}
                  type="file"
                />
              </Grid>
            </>
          ) : null}
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر الشراء"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={priceamount?.buy_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <>

            
          <Controls.Button
            type="submit"
            disabled={stringDataloading === true ? true : false} 
            text="طلب"
             onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
            variant="contained"
            className={stringDataloading === true ?" btn-submit-disabled" :'btn-submit'}     
          ></Controls.Button>
                  <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
          </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
